import { parseISO } from "../date";
import addClass from "../utilities/add-class";
import removeClass from "../utilities/remove-class";
import bus from "../bus";
import { playerEvents } from "../player/events";

export default function timeslotList(el) {
  const timeslotItems = Array.prototype.slice.call(
    el.querySelectorAll(".list-view__item")
  );

  const timeslots = timeslotItems.map(item => ({
    element: item,
    flagElement: item.querySelector(".flag-label__on-air-flag"),
    listenNowContainerElement: item.querySelector(".listen-now-container")
  }));

  // Update timeslot states, then check for the active timeslot every 10 seconds
  updateTimeslots();
  const intervalID = window.setInterval(updateTimeslots, 10000);

  // Add a click handler for the Listen now link
  function onClick(e) {
    if (e.target.classList && e.target.classList.contains("listen-now")) {
      e.preventDefault();
      bus.emit(playerEvents.PLAY_DEFAULT_STREAM);
      bus.emit(playerEvents.PLAY);
    }
  }

  el.addEventListener("click", onClick);

  function updateTimeslots() {
    timeslots.forEach(timeslot => updateTimeslot(timeslot));
  }

  function updateTimeslot(timeslot) {
    if (timeslotIsOnAir(timeslot)) {
      activateTimeslot(timeslot);
    } else {
      deactivateTimeslot(timeslot);
    }
  }

  function timeslotIsOnAir(timeslot) {
    const startTime = parseISO(timeslot.element.dataset.timeslotStart);
    const endTime = parseISO(timeslot.element.dataset.timeslotEnd);
    const now = new Date();
    return startTime <= now && now < endTime;
  }

  function activateTimeslot(timeslot) {
    addClass(timeslot.element, "list-view__item--active");
    removeClass(timeslot.flagElement, "flag-label__on-air-flag--hidden");
    removeClass(
      timeslot.listenNowContainerElement,
      "list-view__actions--hidden"
    );
  }

  function deactivateTimeslot(timeslot) {
    removeClass(timeslot.element, "list-view__item--active");
    addClass(timeslot.flagElement, "flag-label__on-air-flag--hidden");
    addClass(timeslot.listenNowContainerElement, "list-view__actions--hidden");
  }

  function destroy() {
    window.clearInterval(intervalID);
    el.removeEventListener("click", onClick);
  }

  return {
    destroy: () => {
      destroy();
    }
  };
}
